// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Avatar } from 'primereact/avatar';
import { Dialog } from 'primereact/dialog';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Styling
import './dashboard.scss';

// Redux
import { connect } from 'react-redux';
import { getAssociateData } from '../../redux/actions/profile';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Utils
import { getPrettyDate } from '../../common/utils/date-utils';
import { ACTION_LOG_DATA } from '../../common/constants';
import { isMobileOnly } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import QuoteService from '../../redux/services/quote';
import { QUOTE_PAYMENT_PLAN_NOTIFIED } from '../../common/lists/quote';
import AssociateService from '../../redux/services/associate';

class DashboardPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
        alertVisible: false,
        scapContentModalVisible: false,
        scapApproval: false
    };
  }

  componentDidMount() {
        QuoteService.checkAssociateEligibityForQuotePaymentPlan(this.props.associate.associateId)
        .then((response) => {
            if(response.eligible && response.paymentPlan !== null) {
                if(response.paymentPlan.paymentPlanStateId === QUOTE_PAYMENT_PLAN_NOTIFIED) {
                    this.setState({ alertVisible: true });
                }
            }
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });

        AssociateService.getScapContentResponseStatus(this.props.associate.associateId)
        .then((response) => {
            this.setState({ scapContentModalVisible: (response.consentCompleted === false) });
            this.setState({ scapApproval: response.consentAccepted });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
        });
  }

  goToQuotes() {
    this.setState({ alertVisible: false, scapContentModalVisible: false });
    window.open(process.env.PUBLIC_URL + "/quotes", "_self");
  }

  consentDataToScap(decision) {
    AssociateService.updateScapConsent({
        associateId: this.props.associate.associateId,
        approval: decision
    })
    .then((response) => {
        this.setState({ scapContentModalVisible: false, scapApproval: decision });
    })
    .catch(error => {
        this._toast.current.show({ severity: 'error', detail: this.props.t("quotes.messages.error"), life: 3000 });
    });
  }

  render() {
    const quotesHeaderElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <i className="pi pi-exclamation-triangle" style={{fontSize:"1.5rem", color: "orange"}} />
            <span className="font-bold white-space-nowrap">{this.props.t("quotes.dialog.quotes-alert-title")}</span>
        </div>
    );

    const quotesFooterContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={() => this.goToQuotes()} autoFocus />
        </div>
    );

    const scapHeaderElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <i className="pi pi-info-circle" style={{fontSize:"1.5rem", color: "#0073aa"}} />
            <span className="font-bold white-space-nowrap">{this.props.t("dashboard.scap-modal-title")}</span>
        </div>
    );

    const scapFooterContent = (
        <div>
            <Button label={this.props.t("general.yes")} className='p-button-success' icon="pi pi-check" onClick={() => this.consentDataToScap(true)} />
            <Button label={this.props.t("general.no")} className='p-button-danger' icon="pi pi-times" onClick={() => this.consentDataToScap(false)} />
        </div>
    );

    return (
      <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
          <div className='col-1'></div>
          <div className='col-10'>
              <div className="card mgt-20 t-align-left">
                  {
                      this.props.associate !== null && this.props.associate.personalData !== null ?
                        <h4>{this.props.t("dashboard.welcome")} {this.props.associate.personalData.name}</h4>
                        : null
                  }
                  {
                    !this.props.internal ?
                        <>
                            <hr/>
                            <div className="grid">
                                <div className='col-12 md:col-12 lg:col-2 t-align-center'>
                                    {
                                    !isMobileOnly && this.props.profilePicture !== null ? 
                                    <Avatar style={{width: '10rem', height: '10rem'}} image={"data:image/png;base64," + this.props.profilePicture} size="large" shape="circle"></Avatar>
                                    : null
                                    }
                                </div>
                                <div className='col-6 md:col-6 lg:col-3 t-align-left mgt-20'>
                                    <p style={{fontSize:"smaller", color:"grey", marginBottom:"0.5rem"}}>{this.props.t("dashboard.professional-name")}</p>
                                    {
                                        this.props.associate !== null && this.props.associate.personalData !== null ?
                                        <p style={{fontSize:"16px", color:"#2959AD"}}>{this.props.associate.personalData.professionalName}</p>
                                        : null
                                    }
                                </div>
                                <div className='col-6 md:col-6 lg:col-3 t-align-left mgt-20'>
                                    <p style={{fontSize:"smaller", color:"grey", marginBottom:"0.5rem"}}>{this.props.t("dashboard.ballot")}</p>
                                    {
                                        this.props.associate !== null && this.props.ballot !== null ?
                                        <p style={{fontSize:"16px", color:"#2959AD"}}>{this.props.ballot.ballotRef}</p>
                                        : null
                                    }
                                </div>
                                <div className='col-6 md:col-6 lg:col-2 t-align-left mgt-20'>
                                    <p style={{fontSize:"smaller", color:"grey", marginBottom:"0.5rem"}}>{this.props.t("dashboard.admission-date")}</p>
                                    {
                                        this.props.associate !== null && this.props.ballot !== null ?
                                        <p style={{fontSize:"16px", color:"#2959AD"}}>{getPrettyDate(this.props.ballot.admissionDate)}</p>
                                        : null
                                    }
                                </div>
                                <div className='col-6 md:col-6 lg:col-2 t-align-left mgt-20'>
                                    <p style={{fontSize:"smaller", color:"grey", marginBottom:"0.5rem"}}>{this.props.t("dashboard.due-date")}</p>
                                    {
                                        this.props.associate !== null && this.props.ballot !== null ?
                                        <p style={{fontSize:"16px", color:"#2959AD"}}>{getPrettyDate(this.props.ballot.dueDate)}</p>
                                        : null
                                    }
                                </div>
                            </div>
                        </>
                        : null
                  }
                  
              </div>
              <div className="grid">
                  {
                      this.props.actionLog ?
                        <div className='col-12 md:col-12 lg:col-6'>
                            <div className="card t-align-left">
                                <div className="flex align-items-center justify-content-between mb-4">
                                    <h5>{this.props.t('dashboard.actions')}</h5>
                                    <Link to={process.env.PUBLIC_URL + "/actions"}><h6 style={{marginTop: "0px"}}><a href=''>Ver todas</a></h6></Link>
                                </div>
                                {
                                    this.props.actionLog.length === 0 ?
                                        <span className="text-700">{this.props.t('dashboard.no-actions')}</span>
                                        : null
                                }
                                {
                                    this.props.actionLog.length !== 0 ?
                                        this.props.actionLog.map((action) => { 
                                            return <div key={action.actionDate}>
                                                <span className="block text-600 font-medium mb-3">{action.actionDate}</span>
                                                <ul className="p-0 mx-0 mt-0 mb-4 list-none">
                                                    {
                                                        action.entries.map((entry) => { 
                                                            return <li key={entry.message} className="flex align-items-center py-2 border-bottom-1 surface-border">
                                                                    <div className="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                                                                        {
                                                                            entry.type === ACTION_LOG_DATA ? 
                                                                                <i className="pi pi-pencil text-xl text-blue-500"/>
                                                                                : 
                                                                                <i className="pi pi-euro text-xl text-blue-500"/>
                                                                        }
                                                                    </div>
                                                                    <span className="text-900 line-height-3">{entry.message}	</span>
                                                                </li>;
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        })
                                        : null
                                }
                            </div>
                        </div>: null
                  }
                  <div className='col-12 md:col-12 lg:col-6'>
                      <div className="card t-align-left">
                          <div className="flex align-items-center justify-content-between mb-4">
                              <h5>{this.props.t('dashboard.notifications')}</h5>
                          </div>
                          {
                            this.state.scapApproval ?
                                <span className="text-700">{this.props.t('dashboard.no-notifications')}</span>
                                :
                                <div className="grid">
                                    <div className='col-9 t-align-left mgt-20'>
                                        <p style={{color:"grey", marginBottom:"0.5rem"}}>{this.props.t("dashboard.scap-modal-content")} <a href="https://www.autenticacao.gov.pt" target="_blank">Autenticação.gov</a> {this.props.t("dashboard.scap-modal-content-2")} <a href="https://www.gov.pt" target="_blank">Gov.pt</a>?</p>
                                    </div>
                                    <div className='col-3 t-align-right mgt-20'>
                                        <Button label={this.props.t("general.yes")} className='p-button-success' icon="pi pi-check" onClick={() => this.consentDataToScap(true)} />
                                    </div>
                                </div>
                          }
                          
                      </div>
                  </div>
              </div>
          </div>
          <div className='col-1'></div>
          <Dialog visible={this.state.alertVisible} modal header={quotesHeaderElement} footer={quotesFooterContent} style={{ width: '50rem'}}>
            <p className="m-0" style={{fontSize:"14px"}}>
                {this.props.t("quotes.dialog.quotes-alert-1")} <b>{this.props.t("quotes.dialog.quotes-alert-2")}</b>.
            </p>
        </Dialog>
          <Dialog visible={this.state.scapContentModalVisible} modal header={scapHeaderElement} footer={scapFooterContent} style={{ width: '50rem'}} closable={false} closeOnEscape={false}>
            <p className="m-0" style={{fontSize:"14px"}}>
                {this.props.t("dashboard.scap-modal-content")} <a href="https://www.autenticacao.gov.pt" target="_blank">Autenticação.gov</a> {this.props.t("dashboard.scap-modal-content-2")} <a href="https://www.gov.pt" target="_blank">Gov.pt</a>?
            </p>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      internal: state.authentication.internal,
      associate: state.profile.associate,
      actionLog: state.profile.actionLog,
      profilePicture: state.profile.profilePicture,
      ballot: state.profile.ballot,
      registrationRef: state.authentication.registrationRef
  } 
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(DashboardPage)));